var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"htmlfield relative bg-white"},[_c('VueEditor',{attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"value":_vm.value,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }